import {
  collectEntityRefsFromFields,
  normalizeUserFieldsMap,
  readRawChainField,
  type ChainEntityRef,
} from './chainUserFields'

export interface PlatformUserProfile {
  userFields?: Record<string, unknown> | null
}

export function createOnServerEventUserShim(profile: PlatformUserProfile | null | undefined) {
  const fields = normalizeUserFieldsMap(profile?.userFields ?? undefined)

  return {
    getAllRoles(): ChainEntityRef[] {
      return collectEntityRefsFromFields(fields, ['allRoles', 'roles'])
    },

    getField(name: string): unknown {
      if (name === 'lines') {
        return collectEntityRefsFromFields(fields, ['lines'])
      }
      return readRawChainField(fields, name)
    },
  }
}
